import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import MediaRequests from "services/media";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MediaListElement from "./MediaListElement";
import Pagination from "@material-ui/lab/Pagination";

const useStyles = makeStyles((_) => ({
  mediaListContainer: {
    width: "100%",
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
}));

const MeidaList = ({
  selectMode,
  handleSelect,
  selectedItem,
  imageSelector,
  handleClose,
  gallerySelctor,
  gallerySlected,
  handleSelectGallery,
}) => {
  const { allMedia, mediaTotalPages, mediaCurrentPage } = useSelector(
    ({ media }) => media
  );
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(MediaRequests.getmediaList(1));
  }, []);

  const handleChangePagination = (_, value) => {
    dispatch(MediaRequests.getmediaList(value));
  };

  let mediaList = (
    <Typography variant="h4">موردی برای نمایش وجود ندارد</Typography>
  );

  if (allMedia && allMedia.length !== 0) {
    mediaList = allMedia.map((media) => (
      <MediaListElement
        selectMode={selectMode}
        listElement={media}
        key={media._id}
        handleSelect={handleSelect}
        selectedItem={selectedItem}
        imageSelector={imageSelector}
        gallerySelctor={gallerySelctor}
        handleClose={handleClose}
        gallerySlected={gallerySlected}
        handleSelectGallery={handleSelectGallery}
      />
    ));
  }

  return (
    <>
      <Box className={classes.mediaListContainer}>{mediaList}</Box>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={mediaTotalPages}
          color="primary"
          page={mediaCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default MeidaList;
